/**
 * @generated SignedSource<<f8b90734892240fd131fa28304057309>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateCustomMcpServerInput = {
  authType?: string | null | undefined;
  credentials?: string | null | undefined;
  description?: string | null | undefined;
  id: any;
  name?: string | null | undefined;
  url?: string | null | undefined;
};
export type EditMcpServerRouteUpdateMutation$variables = {
  input: UpdateCustomMcpServerInput;
};
export type EditMcpServerRouteUpdateMutation$data = {
  readonly updateCustomMcpServer: {
    readonly error: string | null | undefined;
    readonly server: {
      readonly authType: string;
      readonly description: string | null | undefined;
      readonly discoveredTools: ReadonlyArray<string>;
      readonly id: any;
      readonly isActive: boolean;
      readonly name: string;
      readonly toolCount: number;
      readonly url: string;
    } | null | undefined;
  };
};
export type EditMcpServerRouteUpdateMutation = {
  response: EditMcpServerRouteUpdateMutation$data;
  variables: EditMcpServerRouteUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CustomMcpServerPayload",
    "kind": "LinkedField",
    "name": "updateCustomMcpServer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLCustomMcpServer",
        "kind": "LinkedField",
        "name": "server",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "authType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discoveredTools",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toolCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditMcpServerRouteUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditMcpServerRouteUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "452bc5b6562e6610280f096c5f70952a",
    "id": null,
    "metadata": {},
    "name": "EditMcpServerRouteUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation EditMcpServerRouteUpdateMutation(\n  $input: UpdateCustomMcpServerInput!\n) {\n  updateCustomMcpServer(input: $input) {\n    server {\n      id\n      name\n      description\n      url\n      authType\n      isActive\n      discoveredTools\n      toolCount\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "486175dc121849cd15e9ee64e384a93f";

export default node;
